module.exports = __webpack_public_path__ + "static/img/xt-detail.9ab18b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/XT/xt-detail.jpg
// module id = tJK/
// module chunks = 0